import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import FormPrompt from "../DailogBoxes/formprompt";
import AlertDialogBox from "../DailogBoxes/alertdailogbox";
import ConfirmDialogBox from "../DailogBoxes/confirmdailogbox";
import ErorrDialogBox from "../DailogBoxes/errordaologbox";
import Service from "../../Service/firebase";
import AddWorkDetails from "./addworkdetails";
import { setworkdetails } from "../../actions/setworkdetailsaction";
import { isVendorRole, getVendorId } from "../../utils/rbac";

import "./workdetailslist.css";

const WorkDetailsList = (props) => {
  const history = useHistory();
  const vendorLocked = isVendorRole();
  const lockedVendorId = vendorLocked ? getVendorId() : "";
  const [isLoading, setIsLoading] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);
  const [openFormDailog, setOpenFormDailog] = useState(false);
  const [openAlertDailog, setOpenAlertDailog] = useState(false);
  const [openErrorDailog, setOpenErrorDailog] = useState(false);
  const [openConfirmDailog, setOpenConfirmDailog] = useState(false);
  const [allWorkDetailsList, setAllWorkDetailsList] = useState([]);
  const [workDetailsList, setWorkDetailsList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [selectedVendorFilter, setSelectedVendorFilter] = useState(lockedVendorId);
  const [vendorCodeFilter, setVendorCodeFilter] = useState("");
  const [vendorCodeFilterError, setVendorCodeFilterError] = useState("");
  const [selectedId, setSelectedId] = useState("");

  useEffect(() => {
    onFetchAll();
  }, []);

  const onFetchAll = async () => {
    setIsLoading(true);
    const [fetched, fetchedVendors] = await Promise.all([
      Service.getAllData("workDetails"),
      Service.getAllData("vendors"),
    ]);
    setAllWorkDetailsList(fetched);
    setWorkDetailsList(fetched);
    setVendorList(fetchedVendors);
    setIsLoading(false);
  };

  useEffect(() => {
    let filtered = [...allWorkDetailsList];
    if (selectedVendorFilter) {
      filtered = filtered.filter((w) => w.vendorId === selectedVendorFilter);
    }
    setWorkDetailsList(filtered);
  }, [selectedVendorFilter, allWorkDetailsList]);

  const handleVendorCodeFilterSearch = () => {
    if (!vendorCodeFilter) {
      setSelectedVendorFilter("");
      setVendorCodeFilterError("");
      return;
    }
    const found = vendorList.find((v) => v.vendorCode === vendorCodeFilter);
    if (found) {
      setSelectedVendorFilter(found.uid);
      setVendorCodeFilterError("");
    } else {
      setVendorCodeFilterError("Vendor code not found");
    }
  };

  const getVendorCode = (vendorId) => {
    const vendor = vendorList.find((v) => v.uid === vendorId);
    return vendor ? vendor.vendorCode || vendorId : vendorId;
  };

  const handleOnEdit = (item) => {
    props.setOnWorkDetails(item);
    history.push("/editworkdetails");
  };

  const handleOnDelete = (id) => {
    setSelectedId(id);
    setOpenConfirmDailog(true);
  };

  const deleteData = async () => {
    setIsDeleting(true);
    const res = await Service.deleteData("workDetails", selectedId);
    if (res === "success") {
      setIsDeleting(false);
      setOpenConfirmDailog(false);
      setAllWorkDetailsList((prev) => prev.filter((w) => w.workDetailsId !== selectedId));
    } else {
      setIsDeleting(false);
      setOpenErrorDailog(true);
    }
  };

  const handleSuccessDailog = () => {
    setOpenFormDailog(false);
    setOpenAlertDailog(true);
    onFetchAll();
  };

  let count = 0;

  return isLoading ? (
    <div className="workdetailslistpage">
      <i className="fas fa-spinner fa-pulse fa-2x"></i>
    </div>
  ) : (
    <div className="workdetailslistpage">
      <div className="main_section">
        <ConfirmDialogBox
          openDailog={openConfirmDailog}
          onSetOpenDailog={() => setOpenConfirmDailog(false)}
          handleConfirmOkBtn={deleteData}
          isLoading={isDeleting}
          title="Delete"
          des="Are you sure you want to delete this work detail?"
        />
        <AlertDialogBox
          openDailog={openAlertDailog}
          onSetOpenDailog={() => setOpenAlertDailog(false)}
          title="Success"
          des="Work details saved successfully"
        />
        <ErorrDialogBox
          openDailog={openErrorDailog}
          onSetOpenDailog={() => setOpenErrorDailog(false)}
          title="Error"
          des="Something went wrong. Try again"
        />

        <FormPrompt
          openDailog={openFormDailog}
          title="Add Work Details"
          onSetOpenDailog={() => setOpenFormDailog(false)}
        >
          <AddWorkDetails
            handleSuccessDailog={handleSuccessDailog}
            handleErrorDailog={() => {
              setOpenFormDailog(false);
              setOpenErrorDailog(true);
            }}
          />
        </FormPrompt>

        <div className="topheader">
          <ul>
            <li>
              <i className="fa fa-arrow-circle-o-right fa-2x" aria-hidden="true"></i>
            </li>
            <li>
              <h5>Work Details</h5>
            </li>
          </ul>
        </div>
        <hr />

        {/* Filter bar */}
        <div
          style={{
            background: "#f8f9fa",
            border: "1px solid #dee2e6",
            borderRadius: "6px",
            padding: "12px 16px",
            marginBottom: "16px",
          }}
        >
          <div className="form-row align-items-end">
            {!vendorLocked && (
            <div className="col-md-4 mb-2">
              <label style={{ fontSize: "12px", fontWeight: "600", marginBottom: "4px" }}>
                Filter by Vendor Code
              </label>
              <div className="input-group input-group-sm">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter vendor code"
                  value={vendorCodeFilter}
                  onChange={(e) => {
                    setVendorCodeFilter(e.target.value);
                    if (!e.target.value) {
                      setSelectedVendorFilter("");
                      setVendorCodeFilterError("");
                    }
                  }}
                  onKeyDown={(e) => e.key === "Enter" && handleVendorCodeFilterSearch()}
                />
                <div className="input-group-append">
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={handleVendorCodeFilterSearch}
                  >
                    <i className="fa fa-search"></i>
                  </button>
                </div>
              </div>
              {vendorCodeFilterError && <small style={{ color: "red" }}>{vendorCodeFilterError}</small>}
              {selectedVendorFilter && !vendorCodeFilterError && (
                <small style={{ color: "green" }}>
                  {vendorList.find((v) => v.uid === selectedVendorFilter)?.salonName || "Vendor found"}
                </small>
              )}
            </div>
            )}
            <div className="col-md-3 mb-2">
              <button
                className="btn btn-sm btn-secondary"
                onClick={() => {
                  setSelectedVendorFilter("");
                  setVendorCodeFilter("");
                  setVendorCodeFilterError("");
                }}
              >
                Clear
              </button>
            </div>
            <div className="col-md-5 mb-2 text-right">
              <button
                className="btn btn-sm btn-primary"
                onClick={() => setOpenFormDailog(true)}
              >
                + Add Work Details
              </button>
            </div>
          </div>
        </div>

        <table className="table table-striped">
          <thead className="thead tablehead">
            <tr>
              <th scope="col">#</th>
              <th scope="col">Vendor Code</th>
              <th scope="col">Opening Time</th>
              <th scope="col">Closing Time</th>
              <th scope="col">Off Day</th>
              <th scope="col">Option</th>
            </tr>
          </thead>
          <tbody className="tablebody">
            {workDetailsList.length === 0 ? (
              <tr>
                <td colSpan="6">No work details found</td>
              </tr>
            ) : (
              workDetailsList.map((w) => {
                count++;
                return (
                  <tr key={w.workDetailsId || w.vendorId}>
                    <td className="align-middle">{count}</td>
                    <td className="align-middle">{getVendorCode(w.vendorId)}</td>
                    <td className="align-middle">{w.opening_time}</td>
                    <td className="align-middle">{w.closing_time}</td>
                    <td className="align-middle">{w.off_day}</td>
                    <td className="align-middle">
                      <button
                        type="button"
                        className="btn btn-success btn-sm mr-1"
                        onClick={() => handleOnEdit(w)}
                      >
                        <i className="fa fa-edit"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => handleOnDelete(w.workDetailsId)}
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setOnWorkDetails: (p) => dispatch(setworkdetails(p)),
});

export default connect(null, mapDispatchToProps)(WorkDetailsList);
